import { render, staticRenderFns } from "./emailTrigger.vue?vue&type=template&id=3d79c72a&scoped=true"
import script from "./emailTrigger.vue?vue&type=script&lang=js"
export * from "./emailTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d79c72a",
  null
  
)

export default component.exports